import React from 'react';
import { WebsiteCard } from './WebsiteCard';
import { MetaAdsCard } from './MetaAdsCard';
import { CRMCard } from './CRMCard';
import { useLanguage } from '../contexts/LanguageContext';
export function Services() {
  const {
    t
  } = useLanguage();
  return <section id="servicios" className="bg-kinetic-alt py-16 md:py-24 px-5 sm:px-6" data-id="element-224" data-mp="1dw5a5ic3e7kr">
      <div className="container mx-auto" data-id="element-225" data-mp="18uobzukzsz7v">
        <span className="inline-flex items-center text-xs text-cyan-400 uppercase tracking-widest" data-id="element-226" data-mp="13vl6ya50iszw">
          <span className="w-2 h-2 rounded-full bg-cyan-400 inline-block mr-2 animate-pulse-dot" data-id="element-227" data-mp="z5ej4cibrcip" />
          {t.services_label}
        </span>

        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 sm:gap-6 mt-4" data-id="element-228" data-mp="u6l4uhv7rhhh">
          <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-black text-white max-w-lg" data-id="element-229" data-mp="q6183fejyfvv">
            {t.services_heading}
          </h2>
          <p className="text-white/50 text-sm sm:text-base max-w-sm" data-id="element-230" data-mp="g6k6pa6c2o5p">{t.services_intro}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-10 sm:mt-16" data-id="element-231" data-mp="36by14oj0kpk2">
          <WebsiteCard data-id="element-232" data-mp="3b368zg4p42v4" />
          <MetaAdsCard data-id="element-233" data-mp="3b3ppqtim0l7k" />
          <CRMCard data-id="element-234" data-mp="3b3zjms6rzcij" />
        </div>
      </div>
    </section>;
}